<template>
  <!-- 待完成 -->
  <div class="solution_box">
    <!-- 标题 -->
    <div class="solution_title">產業解決方案</div>
    <!-- 内容 -->
    <div class="solution_content_box">
      <!-- 1 -->
      <div class="solution01">
        <!-- 1-st -->
        <div class="solution">
          <img src="@/assets/img/home/icon_solution_text01.png" alt="">
          <div class="solution_content content_red">
            <div title="title_box">
              <h3 class="title_content">
                中小企業
                <div class="cut_off"></div>
              </h3>
              <!--  -->
              <p class="content_box">
                台易購提供您至少五種以上支付工具，讓你輕鬆跨平台使用，無論商家開店、個人使用均無往不利，無痛管理！台易購提供您至少五種以上支付工具，讓你輕鬆跨平台使用，無論商家開店、個人使用均無往不利，無痛管理！
              </p>
              <p class="content_more">了解詳情</p>
            </div>
          </div>
        </div>
        <!-- 1-end -->
      </div>
      <!-- 2 -->
      <div class="solution02">
        <img class="animate02" src="../../../assets/img/home/icon_solution02.png" alt="">
        <img class="animate01" src="../../../assets/img/home/icon_solution01.png" alt="">
        <!-- 2-st -->
        <div class="solution solution_blue">
          <img src="@/assets/img/home/icon_solution_text02.png" alt="">
          <div class="solution_content content_blue">
            <div title="title_box">
              <h3 class="title_content title_content_blue">
                自有品牌
                <div class="cut_off"></div>
              </h3>
              <!--  -->
              <p class="content_box">
                台易購提供您至少五種以上支付工具，讓你輕鬆跨平台使用，無論商家開店、個人使用均無往不利，無痛管理！台易購提供您至少五種以上支付工具，讓你輕鬆跨平台使用，無論商家開店、個人使用均無往不利，無痛管理！
              </p>
              <p class="content_more">了解詳情</p>
            </div>
          </div>
        </div>
        <!-- 2-end -->
      </div>
      <!-- 3 -->
      <div class="solution03">
        <img class="animate03" src="../../../assets/img/home/icon_solution03.png" alt="">
        <img class="animate04" src="../../../assets/img/home/icon_solution02.png" alt="">
        <!-- 3-st -->
        <div class="solution solution_yellow">
          <img src="@/assets/img/home/icon_solution_text03.png" alt="">
          <div class="solution_content content_yellow">
            <div title="title_box">
              <h3 class="title_content title_content_yellow">
                個人賣家
                <div class="cut_off"></div>
              </h3>
              <!--  -->
              <p class="content_box">
                台易購提供您至少五種以上支付工具，讓你輕鬆跨平台使用，無論商家開店、個人使用均無往不利，無痛管理！台易購提供您至少五種以上支付工具，讓你輕鬆跨平台使用，無論商家開店、個人使用均無往不利，無痛管理！
              </p>
              <p class="content_more">了解詳情</p>
            </div>
          </div>
        </div>
        <!-- 3-end -->
      </div>
    </div>
    <!-- 分割线 -->
    <div class="cut_off"></div>
  <!--  -->
  </div>
</template>

<script>
import $ from 'jquery';

export default {
  name: 'HomeSolution',
  props: {
  },
  data() {
    return {
    }
  },
  created(){

    // JQ 動畫

    $(() =>{
      // 1
      $('.animate01').mouseenter(function(){
        $('.solution02').animate({
          left: '70vw'
        },800);
        $('.solution03').animate({
          left: '85vw'
        },800,function(){
          $('.animate02').show();
          $('.animate03').show();
          $('.animate01').hide();
          $('.animate04').hide();

        });
      })

      // 2,4
      $('.animate02,.animate04').mouseenter(function(){
        $('.solution02').animate({
          left: '0vw'
        },800);
        $('.solution03').animate({
          left: '85vw'
        },800, function(){
          $('.animate01').show();
          $('.animate03').show();
          $('.animate02').hide();
          $('.animate04').hide();

        });
      })

      // 3
      $('.animate03').mouseenter(function(){
        $('.solution02').animate({
          left: '0vw'
        },800);
        $('.solution03').animate({
          left: '15vw'
        },800, function(){
          $('.animate01').show();
          $('.animate04').show();
          $('.animate02').hide();
          $('.animate03').hide();
        });
      })
      
    // JQ-end
    })
    
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.solution_box {
  overflow: hidden;
}
/* 分割线 */
  .cut_off {
    background: #e8e8e8;
    height: 2px;
    margin: 68px 174px;
  }
/* 标题 */
  .solution_title {
    font-size: 27px;
    color: #000000;
    text-align: center;
    font-weight: bold;
    margin-bottom: 67px;
    min-width: 1000px;
  }
/* 内容 */
  .solution_content_box {
    width: 100vw;
    height: 30.6vw;
    overflow: hidden;
    position: relative;
  }
  .solution {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 70vw;
    height: 30.6vw;
    background: #ffc5ba;
  }
  .solution img {
    width: 23.9vw;
    height: 18.8vw;
  }
  .solution_content {
    width: 36.5vw;
    height: 23.2vw;
    padding: 3.3vw;
    box-sizing: border-box;
    color: black;
    font-size: 27px;
  }
  .animate01, .animate04 {
    display: none;
  }
/* 1 */
  .solution01 {
    position: absolute;
    left: 0px;
    top: 0px;
  }
/* 2 */
  .solution02 {
    display: flex;
    position: absolute;
    left: 70vw;
  }
  .solution02 > img {
    width: 15vw;
    height: 30.6vw;
  }
  .solution03 {
    display: flex;
    position: absolute;
    left: 85vw;
  }
  .solution03 > img {
    width: 15vw;
    height: 30.6vw;
  }
  .content_box {
    line-height: 20px;
    margin: 0.5vw 0;
    font-size: 13px;
  }
  .content_more {
    text-align: right;
    font-size: 15px;
    float: right;
    padding-bottom: 0.6vw;
    border-bottom: 2px solid #000;

  }
  .solution_blue {
    background: #a8e7e8;
  }
  .solution_yellow {
    background: #ffde6c;
  }
  .content_red {
    background: #ffdcd5;
  }
  .content_blue {
    background: #caf0f1;
  }
  .content_yellow {
    background: #ffeba5;
  }
  .title_content {
    position: relative;
    font-size: 27px;
    font-weight: bold;
    height: 2.7vw;
    background: url("../../../assets/img/home/icon_CC.png") no-repeat right top;
    background-size: contain;
    min-height: 52px;
  }
  .title_content_blue {
    background: url("../../../assets/img/home/icon_BB.png") no-repeat right top;
    background-size: contain;
  }
  .title_content_yellow {
    background: url("../../../assets/img/home/icon_AA.png") no-repeat right top;
    background-size: contain;
  }
  .title_content .cut_off {
    width: 3.5vw;
    height: 0.4vw;
    background: #000000;
    position: absolute;
    margin: 0;
    bottom: 0px;
  }


      /*  */
@media screen and (max-width:768px){
  /* 显示/隐藏 */
  .solution_box {
    display: none;
  }
}
</style>
